import { useQuery } from '@tanstack/react-query';
import { quotesApi } from '../services/api/quotes';
import type { CargoQuoteRequest } from '../types/quotes';
import { formatPriceRange } from '../lib/currency';
import { quoteKeys } from './quoteKeys';

export interface UseClosedOrdersReturn {
  quotes: CargoQuoteRequest[];
  loading: boolean;
  getPriceRange: (responses: CargoQuoteRequest['quote_responses']) => string;
}

const getPriceRange = (responses: CargoQuoteRequest['quote_responses']): string => {
  return formatPriceRange(
    responses.map((r) => ({ price: r.price, currency: r.currency })),
  );
};

export const useClosedOrders = (): UseClosedOrdersReturn => {
  const { data: rawQuotes, isPending } = useQuery({
    queryKey: quoteKeys.list({ status: 'rejected' }),
    queryFn: () => quotesApi.getQuotes({ status: 'rejected' }),
    select: (data) =>
      [...data.cargo_quote_requests].sort(
        (a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime(),
      ),
  });

  const quotes = rawQuotes ?? [];

  return { quotes, loading: isPending, getPriceRange };
};
